module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "mouseleave": _vm.onMouseLeave
    }
  }, _vm._l((_vm.maxRating), function(item, ratingIndex) {
    return _c('span', {
      key: 'rating-' + ratingIndex,
      class: {
        'starActive': _vm.hoverRating >= ratingIndex
      },
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "disabled": _vm.readOnly === true
      },
      on: {
        "mouseover": function($event) {
          return _vm.onMouseOver(ratingIndex)
        },
        "click": function($event) {
          return _vm.onClick(ratingIndex)
        }
      }
    }, [_c('mu-icon', {
      attrs: {
        "size": 24,
        "value": "star",
        "color": _vm.calcStars(ratingIndex)
      }
    })], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c26f89fc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Recipes/Components/RecipeRating.vue
// module id = 3284
// module chunks = 1